/* eslint-disable no-console -- 로거 모듈은 console 사용이 필수적 */
/**
 * 환경별 로깅 유틸리티
 *
 * 개발 환경에서만 console 출력을 허용하고,
 * 프로덕션에서는 자동으로 억제합니다.
 *
 * @module lib/utils/logger
 */

const isDev = process.env.NODE_ENV === 'development';

/**
 * 개발 환경 전용 로거
 *
 * 프로덕션에서는 모든 출력이 자동으로 억제됩니다.
 */
export const logger = {
  error: (...args: unknown[]): void => {
    if (isDev) {
      console.error(...args);
    }
  },
  warn: (...args: unknown[]): void => {
    if (isDev) {
      console.warn(...args);
    }
  },
  info: (...args: unknown[]): void => {
    if (isDev) {
      console.info(...args);
    }
  },
  debug: (...args: unknown[]): void => {
    if (isDev) {
      console.debug(...args);
    }
  },
} as const;
